(() => {
  'use strict';
  if(customElements.get('csb-steel-torch'))return;
  const HEAT_TIME=225, FULL_HEAT=900, SETTLE_TIME=80;
  class CsbSteelTorch extends HTMLElement {
    connectedCallback() {
      if(this.bound)return;
      this.bound=true;this.generation=(this.generation||0)+1;const generation=this.generation;
      this.stage=this.querySelector('.steel-torch-stage');this.canvas=this.querySelector('canvas');
      this.before=this.querySelector('.steel-torch-before');this.after=this.querySelector('.steel-torch-after');
      this.temperature=this.querySelector('.steel-torch-temperature');this.temperatureValue=this.querySelector('[data-torch-temperature]');
      this.cursor=this.querySelector('.steel-torch-cursor');this.status=this.querySelector('.steel-torch-status');
      this.listeners=[];this.frame=0;this.active=false;this.visible=false;this.previewVisible=false;this.ready=false;this.previewing=false;this.introduced=false;this.previewElapsed=0;
      this.preference=window.matchMedia('(prefers-reduced-motion: reduce)');
      const bind=(node,type,fn,options)=>{node.addEventListener(type,fn,options);this.listeners.push([node,type,fn])};
      bind(this.stage,'pointerenter',e=>{if(e.pointerType==='mouse')this.point(e)});
      bind(this.stage,'pointermove',e=>{
        if(e.pointerType!=='mouse'){
          if(this.pendingTap?.id===e.pointerId&&Math.hypot(e.clientX-this.pendingTap.x,e.clientY-this.pendingTap.y)>10)this.pendingTap=null;
          return;
        }
        if(e.cancelable&&this.pointerId===e.pointerId)e.preventDefault();this.point(e);
      },{passive:false});
      bind(this.stage,'pointerdown',e=>{
        if(e.isPrimary===false){this.pendingTap=null;this.stop();return;}
        if(!this.ready||this.full||e.button!==0)return;
        if(e.pointerType!=='mouse'){
          this.stop();this.pendingTap={id:e.pointerId,x:e.clientX,y:e.clientY,time:e.timeStamp??Date.now()};return;
        }
        if(e.cancelable)e.preventDefault();this.pointerId=e.pointerId;this.point(e);
        if(this.active&&!this.previewing){this.pointerId=e.pointerId;this.stage.setPointerCapture?.(e.pointerId);}
      },{passive:false});
      bind(this.stage,'pointerleave',e=>{if(e.pointerType==='mouse'&&!this.previewing&&this.pointerId==null)this.stop()});
      bind(this.stage,'pointercancel',()=>this.stop());
      bind(this.stage,'pointerup',e=>{
        if(e.pointerType!=='mouse'){
          const tap=this.pendingTap;this.pendingTap=null;
          if(tap?.id===e.pointerId&&(e.timeStamp??Date.now())-tap.time<600&&Math.hypot(e.clientX-tap.x,e.clientY-tap.y)<=10){
            this.point(e);if(this.active){this.touchHeating=true;this.tapElapsed=0;}
          }
          return;
        }
        const id=this.pointerId;if(e.pointerId!==id)return;this.pointerId=null;
        if(this.stage.hasPointerCapture?.(id))this.stage.releasePointerCapture(id);
      });
      bind(this.stage,'lostpointercapture',e=>{if(e.pointerId===this.pointerId)this.stop()});
      for(const type of ['selectstart','dragstart','contextmenu'])bind(this.stage,type,e=>{if(this.ready)e.preventDefault()});
      bind(this.querySelector('[data-torch-demo]'),'click',()=>this.playDemo());
      bind(this.querySelector('[data-torch-show]'),'click',()=>this.showAfter());
      bind(this.querySelector('[data-torch-reset]'),'click',()=>this.reset());
      bind(document,'visibilitychange',()=>{if(document.hidden)this.stop();else this.maybeIntro()});
      bind(this.preference,'change',()=>{if(this.preference.matches)this.stop();else this.maybeIntro()});
      bind(window,'blur',()=>this.stop());
      bind(window,'scroll',()=>{this.pendingTap=null;if(!this.previewing)this.stop()});
      bind(window,'focus',()=>this.maybeIntro());
      const prepare=()=>{if(this.isConnected&&generation===this.generation)this.prepare()};
      for(const img of [this.before,this.after]){bind(img,'load',prepare);bind(img,'error',()=>this.stop())}
      this.observer=new IntersectionObserver(entries=>{
        this.visible=entries.some(e=>e.isIntersecting);
        this.previewVisible=entries.some(e=>e.isIntersecting&&e.intersectionRatio>=.6);
        if(!this.visible||(this.previewing&&!this.previewVisible))this.stop();
        this.maybeIntro();
      },{threshold:[0,.6]});this.observer.observe(this.stage);
      prepare();
    }
    prepare() {
      if(this.ready||![this.before,this.after].every(img=>img.complete&&img.naturalWidth))return;
      this.ctx=this.canvas.getContext('2d');if(!this.ctx)return;
      const make=()=>{const c=document.createElement('canvas');c.width=c.height=960;return c};
      this.mask=make();this.layer=make();this.beforeLayer=make();this.afterLayer=make();
      this.maskCtx=this.mask.getContext('2d');this.layerCtx=this.layer.getContext('2d');
      if(!this.maskCtx||!this.layerCtx)return;
      this.paintPhoto(this.beforeLayer,this.before);this.paintPhoto(this.afterLayer,this.after);
      this.ready=true;this.dataset.ready='true';this.querySelector('.steel-torch-originals').hidden=true;
      this.canvas.hidden=false;this.querySelector('.steel-torch-controls').hidden=false;this.reset();this.introduced=false;this.maybeIntro();
    }
    maybeIntro() {
      if(!this.ready||!this.previewVisible||document.hidden||this.manualPaused||this.preference.matches)return;
      if(!this.introduced)this.playDemo();
      else if(this.previewing&&!this.frame){this.active=true;this.last=null;this.frame=requestAnimationFrame(time=>this.tick(time));}
    }
    playDemo() {
      if(!this.ready)return;
      if(this.preference.matches||this.manualPaused){this.showAfter();return;}
      this.reset();this.previewing=true;this.previewElapsed=0;this.dataset.preview='true';
      this.maybeIntro();
    }
    positionCursor(x,y) {
      const rect=this.stage.getBoundingClientRect();
      if(!this.position||Math.hypot(x-this.position.x,y-this.position.y)>.2)this.resetHeat();
      this.overCard=x>=250&&x<=710&&y>=120&&y<=840;
      this.position={x,y};this.cursor.style.left=`${x/960*rect.width}px`;this.cursor.style.top=`${y/960*rect.height}px`;
      this.cursor.hidden=false;this.dataset.active='true';
      this.temperature.hidden=false;
      const px=x/960*rect.width,py=y/960*rect.height,w=this.temperature.offsetWidth||174,h=this.temperature.offsetHeight||68;
      const left=px+42+w>rect.width-8?px-w-18:px+42;
      this.temperature.style.left=`${Math.max(8,Math.min(rect.width-w-8,left))}px`;
      this.temperature.style.top=`${Math.max(8,Math.min(rect.height-h-8,py-h-14))}px`;
    }
    resetHeat() {
      this.stillTime=0;this.hotAnnounced=false;this.updateTemperature(0);
    }
    updateTemperature(dwell) {
      const amount=Math.min(1,(1-Math.exp(-Math.min(FULL_HEAT,dwell)/HEAT_TIME))/(1-Math.exp(-FULL_HEAT/HEAT_TIME)));
      const celsius=Math.min(800,Math.round(800*amount));
      const fahrenheit=Math.min(1470,Math.round(celsius*9/5+32));
      const value=`${celsius}°C / ${fahrenheit.toLocaleString('en-US')}°F`;
      if(this.temperatureValue&&this.temperatureValue.textContent!==value)this.temperatureValue.textContent=value;
      this.temperature?.style.setProperty('--heat',amount.toFixed(4));
      this.dataset.temperature=String(celsius);
      if(celsius===800&&!this.hotAnnounced){this.hotAnnounced=true;this.status.textContent=this.dataset.hotLabel;}
    }
    setPaused(value) {this.manualPaused=Boolean(value);if(value)this.stop();else this.maybeIntro()}
    paintPhoto(canvas,img) {
      const ctx=canvas.getContext('2d'),scale=Math.min(824/img.naturalWidth,824/img.naturalHeight);
      ctx.fillStyle='#ffffff';ctx.fillRect(0,0,960,960);
      ctx.drawImage(img,(960-img.naturalWidth*scale)/2,(960-img.naturalHeight*scale)/2,img.naturalWidth*scale,img.naturalHeight*scale);
    }
    point(event) {
      if(!this.ready||!this.visible||document.hidden||this.full)return;
      const rect=this.stage.getBoundingClientRect();if(!rect.width||!rect.height)return;
      const x=(event.clientX-rect.left)/rect.width*960,y=(event.clientY-rect.top)/rect.height*960;
      if(x<0||x>960||y<0||y>960){this.stop();return;}
      if((!this.introduced||this.previewing)&&(x<240||x>720||y<110||y>850))return;
      if(this.previewing){const pointerId=this.pointerId;this.previewing=false;this.stop();this.pointerId=pointerId;}
      this.introduced=true;this.dataset.preview='false';this.dataset.interacted='true';
      this.positionCursor(x,y);this.active=true;
      if(this.frame)return;
      this.last=null;this.frame=requestAnimationFrame(time=>this.tick(time));
    }
    tick(time) {
      this.frame=0;
      if(!this.active||!this.isConnected||document.hidden||!this.visible){this.stop();return;}
      const elapsed=this.last===null?16:Math.min(50,Math.max(0,time-this.last));this.last=time;
      if(this.previewing){
        this.previewElapsed+=elapsed;
        const q=Math.max(0,Math.min(1,(this.previewElapsed-1400)/500)),t=q*q*(3-2*q);
        this.positionCursor(350+250*t,440+65*Math.sin(t*Math.PI));
      }
      const before=Math.max(0,this.stillTime-SETTLE_TIME);
      this.stillTime=this.overCard?this.stillTime+elapsed:0;
      const dwell=Math.max(0,this.stillTime-SETTLE_TIME),heatElapsed=dwell-before;
      // Moving still heats the surface, at one quarter of the stationary strength.
      // Temperature continues to reset on movement; previous scorch marks remain.
      if(this.overCard){
        this.heat(this.position.x,this.position.y,heatElapsed>0?heatElapsed:elapsed*.25);
        this.updateTemperature(dwell);
      }
      if(this.touchHeating){this.tapElapsed+=elapsed;if(this.tapElapsed>=1600){this.stop();return;}}
      if(this.previewing&&this.previewElapsed>=3600){this.previewing=false;this.dataset.preview='false';this.stop();return;}
      this.frame=requestAnimationFrame(next=>this.tick(next));
    }
    heat(x,y,elapsed) {
      const ctx=this.maskCtx,radius=88,alpha=1-Math.exp(-elapsed/HEAT_TIME);
      const gradient=ctx.createRadialGradient(x,y,0,x,y,radius);
      gradient.addColorStop(0,`rgba(255,255,255,${alpha})`);gradient.addColorStop(.4,`rgba(255,255,255,${alpha*.85})`);gradient.addColorStop(1,'rgba(255,255,255,0)');
      ctx.fillStyle=gradient;ctx.fillRect(x-radius,y-radius,radius*2,radius*2);
      if(!this.started){this.started=true;this.status.textContent=this.dataset.partialLabel;}
      this.render();
    }
    render() {
      this.ctx.clearRect(0,0,960,960);this.ctx.drawImage(this.beforeLayer,0,0);
      this.layerCtx.globalCompositeOperation='source-over';this.layerCtx.clearRect(0,0,960,960);
      this.layerCtx.drawImage(this.afterLayer,0,0);this.layerCtx.globalCompositeOperation='destination-in';this.layerCtx.drawImage(this.mask,0,0);
      this.ctx.drawImage(this.layer,0,0);
    }
    showAfter() {
      if(!this.ready)return;this.previewing=false;this.introduced=true;this.dataset.preview='false';this.stop();this.full=true;this.dataset.full='true';
      this.maskCtx.fillStyle='#fff';this.maskCtx.fillRect(0,0,960,960);this.render();this.status.textContent=this.dataset.afterLabel;
    }
    reset() {
      this.previewing=false;this.introduced=true;this.dataset.preview='false';this.dataset.interacted='false';this.dataset.full='false';
      this.stop();this.full=false;this.started=false;if(!this.ready)return;
      this.maskCtx.clearRect(0,0,960,960);this.render();this.status.textContent=this.dataset.beforeLabel;
    }
    stop() {
      this.pendingTap=null;this.touchHeating=false;this.tapElapsed=0;
      cancelAnimationFrame(this.frame);this.frame=0;this.active=false;this.last=null;const pointerId=this.pointerId;this.pointerId=null;
      if(pointerId!=null&&this.stage?.hasPointerCapture?.(pointerId))this.stage.releasePointerCapture(pointerId);
      this.dataset.active='false';if(this.cursor)this.cursor.hidden=true;
      if(this.temperature)this.temperature.hidden=true;this.position=null;this.resetHeat();
    }
    disconnectedCallback() {
      this.generation++;this.stop();this.observer?.disconnect();
      this.listeners?.forEach(([node,type,fn])=>node.removeEventListener(type,fn));this.listeners=[];this.bound=false;
    }
  }
  customElements.define('csb-steel-torch',CsbSteelTorch);
})();
